<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col xl="5" lg="4" class="fixed-div">
                    <b-row class="full-height" >
                        <b-col cols="12" 
                            class="text-center "
                            :class="{'align-self-end': hospitalUser.image, 'align-self-center':  !hospitalUser.image }"
                        >
                            <h1><img class="logo" src="../../assets/imgs/domik_white_logo.svg" alt=""></h1>
                        </b-col>
                        <b-col v-if="hospitalUser.image" cols="12" class="logo-hospital">
                            <img class="img-fluid" :src="hospitalUser.image" alt="">
                        </b-col>
                    </b-row>
                </b-col>
                <b-col offset-xl="5" xl="7"  offset-lg="4" lg="8" class="order-container">
                    <b-container>
                        <b-tabs content-class="mt-5">
                            <b-tab title="REGISTRO NUEVO" active>
                                <b-row>
                                    <b-col cols="12" class="mb-3">
                                        <h3>¡Bienvenido a la plataforma de registro!</h3>
                                        <p>Escribe tu ID personal, selecciona tu talla de preferencia y nosotros nos encargamos del resto.</p>
                                    </b-col>
                                    <b-col cols="12" class="mb-3">
                                        <b>Datos personales</b>
                                        <p>El texto que aparezca en los campos correspondientes se tomará exactamente como está escrito para realizar el bordado. Se respetará rigurosamente el uso de mayúsculas, minúsculas, acentos y cualquier otro carácter especial.<br>Por favor, verifica que tus datos estén correctos, ya que se bordarán tal cual fueron ingresados.</p>
                                        <p class="error-label" v-if="!checkIfCollaboratorsExist && dataUser.collaborator!=''" :key="checkIfCollaboratorsExist">El número de colaborador ingresaro no se encuentra registrado. Contacte al departamento de soporte.</p>
                                        <p class="error-label" v-if="checkIfCollaboratorsOrderExist && magic_flag" :key="magic_flag">El colaborador ingresado ya realizó una orden</p>
                                    </b-col>
                                    <b-col cols="12" class="mb-3 form-floating">
                                        <input oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type = "number" maxlength = "6" class="form-control" v-model="dataUser.collaborator" @change="checkCollaborators" placeholder="# Matricula" :class="{'required':  (empty && dataUser.collaborator=='')}" @focus="magic_flag = false" @blur="magic_flag = true" id="input-1">
                                        <label for="input-1"># Colaborador</label>
                                        <span class="required-label" :class="{'showlabel': (empty && dataUser.collaborator=='')}">Favor de ingresar datos</span>
                                    </b-col>
                                    <b-col cols="12">
                                        <p><strong>Nota: Asegúrate de que el nombre completo (nombre + apellido materno y paterno) no supere los {{ hospitalUser ? hospitalUser.max_chars : '' }} caracteres en total.</strong></p>
                                    </b-col>
                                    <b-col cols="12" class="mb-3 form-floating">
                                        <input type="text" class="form-control" :disabled="editInfo" :key="editInfo" v-model="dataUser.name" placeholder="Nombres(s)*" :class="{'required':  (empty && dataUser.name=='')}" id="input-1">
                                        <label for="input-1">Nombre(s)</label>
                                        <span class="error-label" v-if="hospitalUser && hospitalUser.max_chars && calculateChars() > hospitalUser.max_chars">Excediste el máximo de {{ hospitalUser ? hospitalUser.max_chars : '' }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ calculateChars() }} caracteres.</span>
                                        <span class="error-label" v-if="dataUser.name.length && (dataUser.name.length) < hospitalUser.min_chars && hospitalUser.min_chars!=0">El minimo de caracteres que se pueden utilizar en los campos es de {{ hospitalUser ? hospitalUser.min_chars : '' }} . Actualmente tienes {{ dataUser.name.length }} caracteres.</span>
                                        <span class="required-label" :class="{'showlabel': (empty && dataUser.name=='')}">Favor de ingresar datos</span>
                                    </b-col>
                                    <b-col cols="12" md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-2" :disabled="editInfo" :key="editInfo" v-model="dataUser.lastname1" placeholder="Apellido Paterno*"  :class="{'required':  (empty && dataUser.lastname1=='')}" type="text"></b-form-input>    
                                        <label for="input-2">Apellido Paterno</label>    
                                        <span class="error-label" v-if="hospitalUser && hospitalUser.max_chars && calculateChars() > hospitalUser.max_chars">Excediste el máximo de {{ hospitalUser ? hospitalUser.max_chars : '' }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ calculateChars() }} caracteres.</span>
                                        <span class="error-label" v-if="dataUser.lastname1.length && (dataUser.lastname1.length) < hospitalUser.min_chars && hospitalUser.min_chars!=0">El minimo de caracteres que se pueden utilizar en los campos es de {{ hospitalUser ? hospitalUser.min_chars : '' }} . Actualmente tienes {{ dataUser.lastname1.length }} caracteres.</span>
                                        <span class="required-label" :class="{'showlabel': (empty && dataUser.lastname1=='')}">Favor de ingresar datos</span>        
                                    </b-col>
                                    <b-col cols="12" md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-3" :disabled="editInfo" :key="editInfo" v-model="dataUser.lastname2" placeholder="Apellido Materno*"  :class="{'required':  (empty && dataUser.lastname2=='')}" type="text"></b-form-input> 
                                        <label for="input-3">Apellido Materno</label>
                                        <span class="error-label" v-if="hospitalUser && hospitalUser.max_chars && calculateChars() > hospitalUser.max_chars">Excediste el máximo de {{ hospitalUser ? hospitalUser.max_chars : '' }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ calculateChars() }} caracteres.</span>
                                        <span class="error-label" v-if="dataUser.lastname2.length && (dataUser.lastname2.length) < hospitalUser.min_chars && hospitalUser.min_chars!=0">El minimo de caracteres que se pueden utilizar en los campos es de {{ hospitalUser ? hospitalUser.min_chars : '' }} . Actualmente tienes {{ dataUser.lastname2.length }} caracteres.</span>
                                    </b-col>
                                    <b-col cols="12" class="mb-3 form-floating">
                                        <b-form-input id="input-4" :key="editInfo" v-model="dataUser.speciality" placeholder="Especialidad" type="text" :class="{'required':  (empty && dataUser.speciality=='')}"></b-form-input>
                                        <label for="input-4">Especialidad</label> 
                                        </b-col>
                                    <!-- <b-col cols="12" class="mb-3 form-floating">
                                        <b-form-input id="input-4" :disabled="true" :key="editInfo" v-model="dataUser.area" placeholder="Puesto" type="text" :class="{'required':  (empty && dataUser.area=='')}"></b-form-input>
                                        <label for="input-4">Puesto</label> 
                                    </b-col> -->
                                    <b-col cols="12" class="mb-3 form-floating">
                                        <b-form-input id="input-4" :disabled="editInfo" :key="editInfo" v-model="dataUser.speciality2" placeholder="Especialidad" type="text"></b-form-input>
                                        <label for="input-4">Especialidad</label> 
                                        <span class="error-label" v-if="dataUser.speciality2.length && (dataUser.speciality2.length) > hospitalUser.max_chars && hospitalUser.max_chars!=0">Excediste el máximo de {{ hospitalUser ? hospitalUser.max_chars : '' }} caracteres que se pueden utilizar en todos los campos. Actualmente tienes {{ dataUser.speciality2.length }} caracteres.</span>
                                        <span class="error-label" v-if="dataUser.speciality2.length && (dataUser.speciality2.length) < hospitalUser.min_chars && hospitalUser.min_chars!=0">El minimo de caracteres que se pueden utilizar en los campos es de {{ hospitalUser ? hospitalUser.min_chars : '' }} . Actualmente tienes {{ dataUser.speciality2.length }} caracteres.</span>
                                    </b-col>
                                    <b-col cols="12" class="mb-3 form-floating">
                                        <b-form-input id="input-2" disabled v-model="dataUser.hospital" placeholder="Nombre de la Empresa o Institución"  :class="{'required':  (empty && dataUser.hospital=='')}" type="text"></b-form-input>    
                                        <label for="input-2">Nombre de la Empresa o Institución</label>     
                                        <span class="required-label" :class="{'showlabel': (empty && dataUser.hopital=='')}">Favor de ingresar datos</span>
                                    </b-col>
                                    <!-- <b-col v-if="checkIfCollaboratorsExist" cols="12" class="mb-3 btn-wrapper">
                                        <b-button v-if="editInfo" class="mb-3 mr-3" v-on:click="editInfoUser">Editar</b-button>
                                        <b-button v-if="!editInfo" class="mb-3 mr-3 btn-cancel" v-on:click="cancelEditInfoUser">Cancelar</b-button>
                                        <b-button v-if="!editInfo" class="mb-3 mr-3" v-on:click="saveEditInfoUser">Guardar</b-button>
                                    </b-col> -->
                                    <!-- FILIPINAS -->
                                    <b-col v-if="hospitalUser.qty_filipinas && arrayScrubs[0].model" cols="12" class="mb-3">
                                        <b>Filipina</b>
                                    </b-col>
                                    <b-col v-if="hospitalUser.qty_filipinas && arrayScrubs[0].model" cols="12" class="mb-1">
                                        <span class="required-label-qty" :class="{'showlabel': (sumScrubs > hospitalUser.qty_filipinas)}">
                                            La cantidad ingresada de filipinas excede el número máximo de elementos que se pueden elegir.
                                        </span>
                                        <p>La cantidad máxima de filipinas que puedes elegir son {{ hospitalUser.qty_filipinas }}</p>
                                    </b-col>
                                    <b-col v-if="hospitalUser.qty_filipinas > 1 && arrayScrubs[0].model" cols="7" class="mb-3">
                                        <button class="btn btn-success mt-2 mb-2" @click="addNewScrub">
                                            Agregar filipina
                                        </button>
                                    </b-col>

                                    <template v-if="hospitalUser.qty_filipinas && arrayScrubs[0].model">
                                        <b-row v-for="(element, index) in arrayScrubs" :key="'scrub-' + index">
                                            <b-col v-if="arrayScrubs.length > 1" cols="10" class="mb-3">
                                                <b>Modelo {{ index + 1 }}</b>
                                            </b-col>
                                            <b-col v-if="arrayScrubs.length > 1" cols="2" style="text-align: right;" class="mb-3">
                                                <a class="trash-icon" v-if="index > 0"
                                                    v-on:click="arrayScrubs.splice(index, 1), arrayPants.splice(index, 1)">
                                                    <!-- SVG trash icon -->
                                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="19" height="19" viewBox="0 0 19 19">
                                                            <defs>
                                                            <clipPath id="clip-path">
                                                                <rect id="Rectangle_70" data-name="Rectangle 70" width="19" height="19" transform="translate(1827 618)" fill="none"/>
                                                            </clipPath>
                                                            </defs>
                                                            <g id="Mask_Group_2" data-name="Mask Group 2" transform="translate(-1827 -618)" clip-path="url(#clip-path)">
                                                            <g id="Icon_feather-trash-2" data-name="Icon feather-trash-2" transform="translate(1829 619)">
                                                                <path id="Path_57" d="M4.5,9H19.734" transform="translate(-4.5 -5.615)" fill="none" stroke="#5a6fbe" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                                                <path id="Path_58" d="M19.348,6.385V18.234a1.693,1.693,0,0,1-1.693,1.693H9.193A1.693,1.693,0,0,1,7.5,18.234V6.385m2.539,0V4.693A1.693,1.693,0,0,1,11.732,3h3.385a1.693,1.693,0,0,1,1.693,1.693V6.385" transform="translate(-5.807 -3)" fill="none" stroke="#5a6fbe" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                                                <path id="Path_59" d="M15,16.5v5.078" transform="translate(-9.076 -8.883)" fill="none" stroke="#5a6fbe" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                                                <path id="Path_60" d="M21,16.5v5.078" transform="translate(-11.69 -8.883)" fill="none" stroke="#5a6fbe" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                                            </g>
                                                            </g>
                                                        </svg>
                                                </a>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="element.model"
                                                    v-model="element.model"
                                                    :options="element.model"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona modelo'"
                                                    :disabled="hasClothesType.scrub ? hasClothesType.scrub.length == 1 : false"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="getColors(element.model)"
                                                    v-model="element.color"
                                                    :options="getColors(element.model)"
                                                    :disabled="getColors(element.model).length == 1"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona color'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" lg="12" xl="6" class="mb-3 size-container">
                                                <div class="qty-container">
                                                    <label for="input-scrub-qty">Cantidad</label>
                                                    <vue-numeric-input
                                                        id="input-scrub-qty"
                                                        :min="0"
                                                        :max="parseInt(hospitalUser.qty_filipinas)"
                                                        v-if="hasClothesType.scrub"
                                                        :disabled="hasClothesType.scrub ? hasClothesType.scrub.length == 1 : false"
                                                        v-model="element.qty"
                                                        :key="element.qty"
                                                        className="form-control-qty"
                                                    ></vue-numeric-input>
                                                </div>
                                            </b-col>

                                            <!-- Bordado -->
                                            <b-col v-if="element.embroidPosition" cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.embroid"
                                                    :options="optionsYN"
                                                    v-on:change="selectEmbroidScrub(index)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Bordado'"
                                                ></single-select>
                                            </b-col>

                                            <template v-if="element.embroid == 'Sí'">
                                                <b-col cols="12" md="12" class="mb-3">
                                                    <b>Bordado</b>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <img class="img-modal" src="../../assets/imgs/img_filipina.svg" alt=""/>
                                                    <div :style="element.embroidPosition.position"></div>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <p style="font-size: 16px;"><strong>Posicion: </strong>{{ element.embroidPosition.text }}</p>
                                                    <p style="font-size: 16px;"><strong>Color de fuente: </strong>{{ element.embroidFontColor ? element.embroidFontColor.name : '' }}</p>
                                                    <p style="font-size: 16px;"><strong>Fuente: </strong>{{ element.embroidFont ? element.embroidFont.name : '' }}</p>
                                                </b-col>
                                            </template>

                                            <!-- Logotipo -->
                                            <b-col v-if="element.logoPosition" cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.logo"
                                                    :options="optionsYN"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Logotipo'"
                                                ></single-select>
                                            </b-col>

                                            <template v-if="element.logo == 'Sí'">
                                                <b-col cols="12" md="12" class="mb-3">
                                                    <b>Logotipo</b>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <img class="img-modal" src="../../assets/imgs/img_filipina.svg" alt=""/>
                                                    <div :style="element.logoPosition.position"></div>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <p style="font-size: 16px;"><strong>Posicion: </strong>{{ element.logoPosition.text }}</p>
                                                    <img class="img-fluid" :src="hospitalUser.image_embroidery" alt=""/>
                                                </b-col>
                                            </template>

                                        </b-row>
                                    </template>
                                    <!-- FIN FILIPINAS -->
                                    
                                    <!-- <hr v-if="hospitalUser.qty_filipinas && arrayScrubs[0].model"> -->
                                    <!-- PANTALONES -->
                                    <b-col v-if="hospitalUser.qty_pantalones && arrayPants[0].model" cols="12" class="mb-3">
                                        <b>Pantalón</b>
                                    </b-col>
                                    <b-col v-if="hospitalUser.qty_pantalones && arrayPants[0].model" cols="12" class="mb-1">
                                        <span class="required-label-qty" :class="{'showlabel': (sumPants > hospitalUser.qty_pantalones)}">
                                            La cantidad ingresada de pantalones excede el número máximo de elementos que se pueden elegir.
                                        </span>
                                        <p>La cantidad máxima de pantalones que puedes elegir son {{ hospitalUser.qty_pantalones }}</p>
                                    </b-col>

                                    <template v-if="hospitalUser.qty_pantalones && arrayPants[0].model">
                                        <b-row v-for="(element, index) in arrayPants" :key="'pants-' + index">
                                            <b-col v-if="arrayPants.length > 1" cols="12" md="12" class="mb-3">
                                                <b>Modelo {{ index + 1 }}</b>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="element.model"
                                                    v-model="element.model"
                                                    :options="element.model"
                                                    placeholder=""
                                                    :required="true"
                                                    :disabled="true"
                                                    :label="'Selecciona modelo'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="getColors(element.model)"
                                                    v-model="element.color"
                                                    :options="getColors(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :disabled="true"
                                                    :label="'Selecciona color'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" lg="12" xl="6" class="mb-3 size-container">
                                                <div class="qty-container">
                                                    <label for="input-pants-qty">Cantidad</label>
                                                    <vue-numeric-input
                                                        id="input-pants-qty"
                                                        :min="0"
                                                        :disabled="true"
                                                        v-model="element.qty"
                                                        :key="element.qty"
                                                        :max="parseInt(hospitalUser.qty_pantalones)"
                                                        className="form-control-qty"
                                                    ></vue-numeric-input>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </template>
                                    <!-- FIN PANTALONES -->
                                    <!-- <hr v-if="hospitalUser.qty_pantalones"> -->

                                    <!-- CHAMARRAS -->
                                    <b-col v-if="arrayJackets[0].model" cols="12" class="mb-3">
                                        <b>Chamarra</b>
                                    </b-col>
                                    <b-col v-if="arrayJackets[0].model" cols="12" class="mb-1">
                                        <span class="required-label-qty" :class="{'showlabel': (sumJackets > hospitalUser.qty_chamarras)}">
                                            La cantidad ingresada de chamarras excede el número máximo de elementos que se pueden elegir.
                                        </span>
                                        <p>La cantidad máxima de chamarras que puedes elegir son {{ hospitalUser.qty_chamarras }}</p>
                                    </b-col>
                                    <b-col v-if="hospitalUser.qty_chamarras > 1" cols="7" class="mb-3">
                                        <button class="btn btn-success mt-2 mb-2" @click="addNewJackets">
                                            Agregar chamarra
                                        </button>
                                    </b-col>

                                    <template v-if="arrayJackets[0].model">
                                        <b-row v-for="(element, index) in arrayJackets" :key="'jacket-' + index">
                                            <b-col v-if="arrayJackets.length > 1" cols="10" class="mb-3">
                                                <b>Modelo {{ index + 1 }}</b>
                                            </b-col>
                                            <b-col v-if="arrayJackets.length > 1" cols="2" style="text-align: right;" class="mb-3">
                                                <a class="trash-icon" v-if="index > 0" v-on:click="arrayJackets.splice(index, 1)">
                                                    <!-- SVG trash icon -->
                                                </a>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="element.model"
                                                    v-model="element.model"
                                                    :options="element.model"
                                                    placeholder=""
                                                    :required="true"
                                                    :disabled="hasClothesType.jacket ? hasClothesType.jacket.length == 1 : false"
                                                    :label="'Selecciona modelo'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="getColors(element.model)"
                                                    v-model="element.color"
                                                    :options="getColors(element.model)"
                                                    :disabled="getColors(element.model).length == 1"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona color'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" lg="12" xl="6" class="mb-3 size-container">
                                                <div class="qty-container">
                                                    <label for="input-jacket-qty">Cantidad</label>
                                                    <vue-numeric-input
                                                        id="input-jacket-qty"
                                                        :min="0"
                                                        v-model="element.qty"
                                                        :key="element.qty"
                                                        :max="parseInt(hospitalUser.qty_chamarras)"
                                                        :disabled="hasClothesType.jacket ? hasClothesType.jacket.length == 1 : false"
                                                        :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                        className="form-control-qty"
                                                    ></vue-numeric-input>
                                                </div>
                                            </b-col>

                                            <!-- Bordado -->
                                            <b-col v-if="element.embroidPosition" cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.embroid"
                                                    :options="optionsYN"
                                                    v-on:change="selectEmbroidScrub(index)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Bordado'"
                                                ></single-select>
                                            </b-col>

                                            <template v-if="element.embroid == 'Sí'">
                                                <b-col cols="12" md="12" class="mb-3">
                                                    <b>Bordado</b>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <img class="img-modal" src="../../assets/imgs/img_chamarra.svg" alt=""/>
                                                    <div :style="element.embroidPosition ? element.embroidPosition.position : ''"></div>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <p style="font-size: 16px;"><strong>Posicion: </strong>{{ element.embroidPosition ? element.embroidPosition.text : '' }}</p>
                                                    <p style="font-size: 16px;"><strong>Color de fuente: </strong>{{ element.embroidFontColor ? element.embroidFontColor.name : '' }}</p>
                                                    <p style="font-size: 16px;"><strong>Fuente: </strong>{{ element.embroidFont ? element.embroidFont.name : '' }}</p>
                                                </b-col>
                                            </template>

                                            <!-- Logotipo -->
                                            <b-col v-if="element.logoPosition" cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.logo"
                                                    :options="optionsYN"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Logotipo'"
                                                ></single-select>
                                            </b-col>

                                            <template v-if="element.logo == 'Sí'">
                                                <b-col cols="12" md="12" class="mb-3">
                                                    <b>Logotipo</b>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <img class="img-modal" src="../../assets/imgs/img_chamarra.svg" alt=""/>
                                                    <div :style="element.logoPosition ? element.logoPosition.position : ''"></div>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <p style="font-size: 16px;"><strong>Posicion: </strong>{{ element.logoPosition ? element.logoPosition.text : '' }}</p>
                                                    <img class="img-fluid" :src="hospitalUser.image_embroidery" alt=""/>
                                                </b-col>
                                            </template>

                                        </b-row>
                                    </template>
                                    <!-- FIN CHAMARRAS -->
                                    
                                    <!-- <hr v-if="hospitalUser.qty_chamarras"> -->
                                    <!-- BATAS -->
                                    <b-col v-if="arrayCoat[0].model" cols="12" class="mb-3">
                                        <b>Bata</b>
                                    </b-col>
                                    <b-col v-if="arrayCoat[0].model" cols="12" class="mb-1">
                                        <span class="required-label-qty" :class="{'showlabel': (sumCoat > hospitalUser.qty_batas)}">
                                            La cantidad ingresada de batas excede el número máximo de elementos que se pueden elegir.
                                        </span>
                                        <p>La cantidad máxima de batas que puedes elegir son {{ hospitalUser.qty_batas }}</p>
                                    </b-col>
                                    <b-col v-if="hospitalUser.qty_batas > 1" cols="7" class="mb-3">
                                        <button class="btn btn-success mt-2 mb-2" @click="addNewCoat">
                                            Agregar bata
                                        </button>
                                    </b-col>

                                    <template v-if="arrayCoat[0].model">
                                        <b-row v-for="(element, index) in arrayCoat" :key="'coat-' + index">
                                            <b-col v-if="arrayCoat.length > 1" cols="10" class="mb-3">
                                                <b>Modelo {{ index + 1 }}</b>
                                            </b-col>
                                            <b-col v-if="arrayCoat.length > 1" cols="2" style="text-align: right;" class="mb-3">
                                                <a class="trash-icon" v-if="index > 0" v-on:click="arrayCoat.splice(index, 1)">
                                                    <!-- SVG trash icon -->
                                                </a>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="element.model"
                                                    v-model="element.model"
                                                    :options="element.model"
                                                    :disabled="hasClothesType.coat ? hasClothesType.coat.length == 1 : false"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona modelo'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="getColors(element.model)"
                                                    v-model="element.color"
                                                    :options="getColors(element.model)"
                                                    :disabled="getColors(element.model).length == 1"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona color'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" lg="12" xl="6" class="mb-3 size-container">
                                                <div class="qty-container">
                                                    <label for="input-coat-qty">Cantidad</label>
                                                    <vue-numeric-input
                                                        id="input-coat-qty"
                                                        :min="0"
                                                        v-model="element.qty"
                                                        :disabled="hasClothesType.coat ? hasClothesType.coat.length == 1 : false"
                                                        :key="element.qty"
                                                        :max="parseInt(hospitalUser.qty_batas)"
                                                        className="form-control-qty"
                                                    ></vue-numeric-input>
                                                </div>
                                            </b-col>

                                            <!-- Bordado -->
                                            <b-col v-if="element.embroidPosition" cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.embroid"
                                                    :options="optionsYN"
                                                    v-on:change="selectEmbroidScrub(index)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Bordado'"
                                                ></single-select>
                                            </b-col>

                                            <template v-if="element.embroid == 'Sí'">
                                                <b-col cols="12" md="12" class="mb-3">
                                                    <b>Bordado</b>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <img class="img-modal" src="../../assets/imgs/img_bata.svg" alt=""/>
                                                    <div :style="element.embroidPosition ? element.embroidPosition.position : ''"></div>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <p style="font-size: 16px;"><strong>Posicion: </strong>{{ element.embroidPosition ? element.embroidPosition.text : '' }}</p>
                                                    <p style="font-size: 16px;"><strong>Color de fuente: </strong>{{ element.embroidFontColor ? element.embroidFontColor.name : '' }}</p>
                                                    <p style="font-size: 16px;"><strong>Fuente: </strong>{{ element.embroidFont ? element.embroidFont.name : '' }}</p>
                                                </b-col>
                                            </template>

                                            <!-- Logotipo -->
                                            <b-col v-if="element.logoPosition" cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.logo"
                                                    :options="optionsYN"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Logotipo'"
                                                ></single-select>
                                            </b-col>

                                            <template v-if="element.logo == 'Sí'">
                                                <b-col cols="12" md="12" class="mb-3">
                                                    <b>Logotipo</b>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <img class="img-modal" src="../../assets/imgs/img_bata.svg" alt=""/>
                                                    <div :style="element.logoPosition ? element.logoPosition.position : ''"></div>
                                                </b-col>
                                                <b-col cols="12" md="6" style="position: relative;" class="mb-3">
                                                    <p style="font-size: 16px;"><strong>Posicion: </strong>{{ element.logoPosition ? element.logoPosition.text : '' }}</p>
                                                    <img class="img-fluid" :src="hospitalUser.image_embroidery" alt=""/>
                                                </b-col>
                                            </template>

                                        </b-row>
                                    </template>
                                    <!-- FIN BATAS -->
                                    <!-- <hr v-if="hospitalUser.qty_batas"> -->
                                    <!-- CALZADO -->
                                    <b-col v-if="arrayShoes[0].model" cols="12" class="mb-3">
                                        <b>Calzado</b>
                                    </b-col>
                                    <b-col v-if="arrayShoes[0].model" cols="12" class="mb-1">
                                        <span class="required-label-qty" :class="{'showlabel': (sumShoes > hospitalUser.qty_zapatos)}">
                                            La cantidad ingresada de calzado excede el número máximo de elementos que se pueden elegir.
                                        </span>
                                        <p>La cantidad máxima de calzado que puedes elegir son {{ hospitalUser.qty_zapatos }}</p>
                                    </b-col>
                                    <b-col v-if="hospitalUser.qty_zapatos > 1" cols="7" class="mb-3">
                                        <button class="btn btn-success mt-2 mb-2" @click="addNewShoes">
                                            Agregar calzado
                                        </button>
                                    </b-col>

                                    <template v-if="arrayShoes[0].model">
                                        <b-row v-for="(element, index) in arrayShoes" :key="'shoes-' + index">
                                            <b-col v-if="arrayShoes.length > 1" cols="10" class="mb-3">
                                                <b>Modelo {{ index + 1 }}</b>
                                            </b-col>
                                            <b-col v-if="arrayShoes.length > 1" cols="2" style="text-align: right;" class="mb-3">
                                                <a class="trash-icon" v-if="index > 0" v-on:click="arrayShoes.splice(index, 1)">
                                                    <!-- SVG trash icon -->
                                                </a>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="element.model"
                                                    v-model="element.model"
                                                    :options="element.model"
                                                    :disabled="hasClothesType.shoes ? hasClothesType.shoes.length == 1 : false"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona modelo'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    :key="getColors(element.model)"
                                                    v-model="element.color"
                                                    :options="getColors(element.model)"
                                                    :disabled="getColors(element.model).length == 1"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona color'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" class="mb-3">
                                                <single-select
                                                    v-model="element.size"
                                                    :options="getSizes(element.model)"
                                                    placeholder=""
                                                    :required="true"
                                                    :label="'Selecciona talla'"
                                                    :class="{'required-select': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}"
                                                ></single-select>
                                                <span class="required-label" :class="{'showlabel': (empty && (dataUser.hospital == '' || dataUser.hospital == null))}">
                                                    Favor de ingresar datos
                                                </span>
                                            </b-col>

                                            <b-col cols="12" md="6" lg="12" xl="6" class="mb-3 size-container">
                                                <div class="qty-container">
                                                    <label for="input-shoes-qty">Cantidad</label>
                                                    <vue-numeric-input
                                                        id="input-shoes-qty"
                                                        :min="0"
                                                        v-model="element.qty"
                                                        :disabled="hasClothesType.shoes ? hasClothesType.shoes.length == 1 : false"
                                                        :key="element.qty"
                                                        :max="parseInt(hospitalUser.qty_zapatos)"
                                                        className="form-control-qty"
                                                    ></vue-numeric-input>
                                                </div>
                                            </b-col>

                                        </b-row>
                                    </template>
                                    <!-- FIN CALZADO -->

                                    <b-col cols="12" class="mb-4">
                                        <p class="required-check" :key="messageEmpty" v-if="messageEmpty">{{messageEmpty}}</p>
                                        <p class="note"><strong>NOTA.</strong> Recuerda que en el bordado se usará de referencia el texto tal cual esté escrito en los campos. Respetaremos mayúsculas, minúsculas, acentos y cualquier otro caracter especial.</p>
                                        <b-form-checkbox
                                            id="checkbox-1"
                                            v-model="status"
                                            name="checkbox-1"
                                            class="mt-2"
                                            :class="{'required-check':  (empty && (status=='' || status==null))}"
                                            >
                                            Confirmo y acepto que la información proporcionada es correcta
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col md="10">
                                        <b-button v-on:click="submitOrder">Continuar</b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab v-if="role=='Admin'|| role=='Super'" title="ESTATUS DE ORDENES" :key="role">
                                <b-row>
                                    <b-col cols="12" class="mb-3">
                                        <h3>Estatus de ordenes</h3>
                                    </b-col>
                                    <b-col v-if="listCollaborators.length>0" md="6" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{listCollaborators.length}}</h3>
                                            <p class="mb-0">Total de ordenes</p>
                                        </div>
                                    </b-col>
                                    <b-col v-if="listCollaborators.length>0" md="6" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{listCollaborators.length - ordersUser.length}}</h3>
                                            <p class="mb-0">Ordenes pendientes por subir</p>
                                        </div>
                                    </b-col>
                                    <b-col md="4" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{ordersUser.length}}</h3>
                                            <p class="mb-0">Ordenes generadas</p>
                                        </div>
                                    </b-col>
                                    <b-col md="4" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{filteredOrdersCompleted.length}}</h3>
                                            <p class="mb-0">Ordenes entregadas</p>
                                        </div>
                                    </b-col>
                                    <b-col md="4" cols="6" class="text-center mb-3">
                                        <div class="orders-count-wrapper">
                                            <h3>{{ordersUser.length - filteredOrdersCompleted.length}}</h3>
                                            <p class="mb-0">Ordenes pendientes por entregar</p>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4 mb-5">
                                    <b-col class="mb-2" md="3" cols="6">
                                        <b-form-select id="status-filter" v-model="statusFilter" :options="statusOptions"></b-form-select>
                                    </b-col>    
                                    <b-col class="mb-2" md="9" cols="12">
                                        <b-form-input id="input-search" v-model="search" placeholder="Buscar # colaborador"  type="text"></b-form-input>    
                                    </b-col>   
                                </b-row>
                                <b-row> 
                                    <b-col cols="12">
                                        <input type="text" class="form-control" placeholder="Buscar # de colaborador" v-model="search" id="input-1">
                                        
                                        <table class="table table-orders b-table">
                                            <thead role="rowgroup">
                                                <tr>
                                                    <th colspan="1">
                                                        No. de <br>col
                                                    </th>
                                                    <th>
                                                        Nombre
                                                    </th>
                                                    <th>
                                                        Estatus
                                                    </th>
                                                    <th>
                                                    </th>
                                                    <th>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody role="rowgroup">
                                                <tr role="row" v-for="(element) in ordersUser" :key="element.id+'col'">
                                                    <td class="td-number">
                                                        {{ element.collaborator_number }}
                                                    </td>
                                                    <td>
                                                        {{ element.name }} {{ element.first_lastname }} {{ element.second_lastname }}
                                                    </td>
                                                    <td>
                                                        {{ element.status }}
                                                    </td>
                                                    <td class="td-btn-details">
                                                        <b-button v-on:click="showModalOrderDetails(element.id)" class="see-details-btn">Ver detalles</b-button>    
                                                    </td>
                                                    <td class="td-btn-details">
                                                        <b-button :disabled="element.status == 'Entregado'" v-on:click="completedStatusOrder(element.id)" class="see-details-btn">Confirmar entrega</b-button>    
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-col>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-container>         

                    <b-modal size="xl" id="modal-view-order" hide-footer centered>
                        <b-row>
                            <span class="title-modal-order">INFORMACIÓN DEL HOSPITAL</span>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="6" class="mb-3 text-left">
                                <b>Nombre</b>
                                <p>{{ ordersUser[index] ? ordersUser[index].name : '' }} {{ ordersUser[index] ? ordersUser[index].first_lastname : ''  }} {{ ordersUser[index] ? ordersUser[index].second_lastname : '' }}</p>
                            </b-col>
                            <b-col cols="12" md="6" class="mb-3 text-left">
                                <b>Nombre del hospital</b>
                                <p>{{ ordersUser[index] ? ordersUser[index].hospital : '' }}</p>
                            </b-col>
                        </b-row>
                        <b-row v-for="item in ordersUser[index] ? ordersUser[index].ownItem : []" :key="item.id+'usertable'">
                            <hr>
                            <b-col cols="12" md="12" class="text-left mb-3">
                                <span class="title-modal-order">{{ item.type }}</span>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Modelo</b>
                                <p>{{ item.model }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Color</b>
                                <p>{{ item.color }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Cantidad</b>
                                <p>{{ item.qty }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Talla</b>
                                <p>{{ item.size }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Género</b>
                                <p>{{ ordersUser[index] ? ordersUser[index].gender : ''}}</p>
                            </b-col>

                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Bordado</b>
                                <p>{{ item.embroid }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Letra</b>
                                <p>{{ item.embroid_font }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Color letra</b>
                                <p>{{ item.embroid_font_color }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Posición de bordado</b>
                                <p>{{ item.embroid_position }}</p>
                            </b-col>
                            <b-col cols="12" md="4" class="mb-3 text-left">
                                <b>Logo</b>
                                <p><img :src="item.logo_image" style="width: 100%" alt=""></p>
                            </b-col>
                        </b-row>
                    </b-modal>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import SingleSelect from '../elements/SingleSelect.vue'
    import VueNumericInput from 'vue-numeric-input'
    import axios from 'axios'
    import qs from 'qs' 
    import _ from 'lodash'

    export default {
        components: {
            SingleSelect,
            VueNumericInput
        },
        created() {
            //Get Session variables
            this.role = sessionStorage.getItem('role')
            var tempModel = [], tempUserInfo, tempCollaborators = []
            var datalist = sessionStorage.getItem('dataUser')
            tempUserInfo = JSON.parse(sessionStorage.getItem('hospital_user'))
            if(tempUserInfo)
                this.hospitalUser = tempUserInfo
            var modelsUser = JSON.parse(sessionStorage.getItem('models_user'))
            this.dataUser.hospital = this.hospitalUser ? this.hospitalUser.name : ''
            this.dataUser.id_hospital = this.hospitalUser ? this.hospitalUser.id : ''

            Object.keys(modelsUser).map((key) => [modelsUser[key]]).map(function(value) {
                tempModel.push(value[0])
            })
            this.optionsModels =  tempModel

            var collaboratorsHospital = JSON.parse(sessionStorage.getItem('collaborators_user'))
            Object.keys(collaboratorsHospital).map((key) => [collaboratorsHospital[key]]).map(function(value) {
                tempCollaborators.push(value[0])
            })
            this.listCollaborators = tempCollaborators

            if (!this.data) {
                this.data = JSON.parse(datalist)
            }
            this.storageUser == datalist
            if (datalist) {
                this.dataUser = JSON.parse(datalist)
                this.arrayJackets = JSON.parse(sessionStorage.getItem('arrayJackets'))
                console.log(JSON.parse(sessionStorage.getItem('arrayScrubs')))
                this.arrayScrubs = JSON.parse(sessionStorage.getItem('arrayScrubs'))
                this.arrayPants = JSON.parse(sessionStorage.getItem('arrayPants'))
                this.arrayCoat = JSON.parse(sessionStorage.getItem('arrayCoat'))
                this.arrayShoes = JSON.parse(sessionStorage.getItem('arrayShoes'))
                this.arrayCaps = JSON.parse(sessionStorage.getItem('arrayCaps'))
            }

            //Prevent modals show
            this.$bvModal.hide('modal-jacket-logo')
            this.$bvModal.hide('modal-coat-logo')
            this.$bvModal.hide('modal-scrub-logo')
            this.$bvModal.hide('modal-pants-logo')
            this.$bvModal.hide('modal-jacket')
            this.$bvModal.hide('modal-coat')
            this.$bvModal.hide('modal-scrub')
            this.$bvModal.hide('modal-pants')


            //Init watcher models
            this.updateWatchersModel()

            this.updateWatchersEmbroid(this.arrayScrubs, 'modal-scrub', 0)
            this.updateWatchersEmbroid(this.arrayJackets, 'modal-jacket', 0)
            this.updateWatchersEmbroid(this.arrayCoat, 'modal-coat', 0)
            this.updateWatchersEmbroid(this.arrayPants, 'modal-pants', 0) 
            
            this.updateWatchersLogo(this.arrayScrubs, 'modal-scrub-logo', 0)
            this.updateWatchersLogo(this.arrayJackets, 'modal-jacket-logo', 0)
            this.updateWatchersLogo(this.arrayCoat, 'modal-coat-logo', 0)
            this.updateWatchersLogo(this.arrayPants, 'modal-pants-logo', 0) 
            
            //Get hospital list

            var token = sessionStorage.getItem('api_token')
            var id_user = sessionStorage.getItem('id_user')
            axios
            .post(
                process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    option: 'get_catalogs',
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    var listHospitals = [], listThreadColor = []
                    Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
                        listHospitals.push(value[0].name)
                    })
                    this.optionsHospitals = listHospitals 

                    Object.keys(response.data.thread_colors).map((key) => [response.data.thread_colors[key]]).map(function(value) {
                        listThreadColor.push(value[0])
                    })
                    this.optionsColor = listThreadColor
                }
            })
            
            this.getAllOrders()

        },
        data() {
            return {
                role: '',
                statusFilter: 'all', // o el valor por defecto que quieras
                statusOptions: [
                    { value: 'all', text: 'Todos' },
                    { value: 'Entregado', text: 'Entregado' },
                    { value: 'No entregado', text: 'Sin entregar' }
                ],
                magic_flag:  true,
                selectedJC: '',
                hospitalUser: {
                    image: '',
                    qty_filipinas: 0,
                    qty_pantalones: 0,
                    qty_chamarras: 0,
                    qty_batas: 0,
                    qty_gorros: 0,
                    qty_zapatos: 0
                },
                previousModelsS: [],
                previousModelsJ: [],
                previousModelsC: [],
                previousModelsP: [],
                messageEmpty: '',
                search: '',
                specialityChars: 0,
                checkIfCollaboratorsExist: false,
                checkIfCollaboratorsOrderExist: false,
                sumJackets: 0,
                sumCoat: 0,
                sumName: 0,
                sumPants: 0,
                sumScrubs: 0,
                storageUser: '',
                editInfo: false,
                ordersUserAll: [],
                index: 0,
                watchModel: [],
                watchTracker: [],
                watchTrackerLogo: [],
                elementJackets: [],
                arrayJackets: [{
                    qty: 0,
                    model: '',
                    size: '',
                    id: 1,
                    color: '',
                    logo: '',
                    logoPosition: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Chamarra',
                    save: false
                }],
                elementCoat: [],
                arrayCoat: [{
                    qty: 0,
                    model: '',
                    size: '',
                    id: 1,
                    color: '',
                    logo: '',
                    logoPosition: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Bata',
                    save: false
                }],
                elementScrubs: [],
                arrayScrubs: [{
                    qty: 0,
                    model: '',
                    size: '',
                    id: 1,
                    color: '',
                    logo: '',
                    logoPosition: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Filipina',
                    save: false 
                }],
                elementPants: [],
                arrayPants: [{
                    qty: 0,
                    model: '',
                    size: '',
                    id: 1,
                    color: '',
                    logo: '',
                    logoPosition: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type:'Pantalon',
                    save: false
                }],
                elementCaps: [],
                arrayCaps: [{
                    qty: 0,
                    model: '',
                    size: '',
                    id: 1,
                    color: '',
                    logo: '',
                    logoPosition: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Gorro',
                    save: false 
                }],
                elementShoes: [],
                arrayShoes: [{
                    qty: 0,
                    model: '',
                    size: '',
                    id: 1,
                    color: '',
                    logo: '',
                    logoPosition: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Calzado',
                    save: false 
                }],
                dataUser:{ 
                    hospital: '',
                    id_hospital: '',
                    area: '',
                    name: '',
                    lastname1: '',
                    lastname2: '',
                    speciality: '',
                    speciality2: '',
                    jobPosition: '',
                    gender: '',
                    embroidery: '',
                    embroideryText: '',
                    phone: '',
                    email: '',
                    modelCoat: [],
                    modelScrub: '',
                    modelPants: '',
                    modelScrubCap: '',
                    saveJacket: '',
                    saveCoat: '',
                    saveScrub: '',
                    savePants: '',
                    collaborator: '',
                    idCollaborator: ''
                },
                tempDataUser:{ 
                    name: '',
                    lastname1: '',
                    speciality: '',
                    speciality2: ''
                },
                listCollaborators: [],
                optionsModels: [],
                optionsGenderAPI: [],
                optionsHospitals: [],
                optionsYN: ['Sí','No'],
                optionsJC: ['Chamarra','Bata'],
                optionsColor: [],
                empty: false,
                status:'',
                statusMailing: ''
            }
        }, 
        watch: {
            hasClothesType(elements) {
                if (!elements) return;

                if (elements.coat.length === 1) {
                    this.applyClothingDefaults(this.arrayCoat[0], elements.coat[0], 'coat',this.hospitalUser.qty_batas);
                }
                if (elements.pants.length === 1) {
                    this.applyClothingDefaults(this.arrayPants[0], elements.pants[0], 'pants',this.hospitalUser.qty_pantalones);
                }
                if (elements.scrub.length === 1) {
                    this.applyClothingDefaults(this.arrayScrubs[0], elements.scrub[0], 'scrub',this.hospitalUser.qty_filipinas);
                }
                if (elements.jacket.length === 1) {
                    this.applyClothingDefaults(this.arrayJackets[0], elements.jacket[0], 'jacket',this.hospitalUser.qty_chamarras);
                }
            },
            arrayScrubs: {
                handler:function(newVal) {
                    if (this._updatingArrayScrubs) return;
                        this._updatingArrayScrubs = true;

                        try {
                            this.updateWatchersModel();
                            this.sumScrubs = this.calculateSum(this.arrayScrubs, 'qty');

                            newVal.forEach((scrub, index) => {
                                if (!this.arrayScrubs[index]) return;

                                if (!scrub.model) {
                                    this.$set(this.arrayScrubs[index], 'qty', 0);
                                    this.$set(this.arrayScrubs[index], 'color', '');
                                    this.$set(this.arrayScrubs[index], 'size', '');
                                }

                                if (
                                    this.previousModelsS[index] !== undefined &&
                                    scrub.model !== this.previousModelsS[index]
                                ) {
                                    
                                    if (this.hospitalUser.embroidery_position_scrubs_logo) {
                                        this.$set(
                                            this.arrayScrubs[index],
                                            'logoPosition',
                                            JSON.parse(this.hospitalUser.embroidery_position_scrubs_logo)
                                        );
                                    }

                                    if (this.hospitalUser.embroidery_position_scrub) {
                                        this.arrayScrubs[index].embroid = 'Sí';
                                        this.$set(
                                            this.arrayScrubs[index],
                                            'embroidPosition',
                                            JSON.parse(this.hospitalUser.embroidery_position_scrub)
                                        );
                                        this.$set(
                                            this.arrayScrubs[index],
                                            'embroidFont',
                                            this.hospitalUser.embroidery_font
                                                ? JSON.parse(this.hospitalUser.embroidery_font)
                                                : null
                                        );
                                        this.$set(
                                            this.arrayScrubs[index],
                                            'embroidFontColor',
                                            this.hospitalUser.embroidery_color
                                                ? JSON.parse(this.hospitalUser.embroidery_color)
                                                : null
                                        );
                                    }
                                }

                                this.$set(this.previousModelsS, index, scrub.model);
                            });
                        } finally {
                            this.$nextTick(() => {
                                this._updatingArrayScrubs = false;  // reset after Vue finishes updating
                            });
                        }
                    },
                    deep: true
                },
            arrayJackets: {
                handler: function(newVal) {
                    if (this._updatingArrayJackets) return;  
                    this._updatingArrayJackets = true;

                    try {
                        this.sumJackets = this.calculateSum(this.arrayJackets, 'qty');

                        newVal.forEach((jacket, index) => {
                            if (!this.arrayJackets[index]) return;

                            if (!jacket.model) {
                                this.$set(this.arrayJackets[index], 'qty', 0);
                                this.$set(this.arrayJackets[index], 'color', '');
                                this.$set(this.arrayJackets[index], 'size', '');
                            }

                            if (
                                this.previousModelsJ[index] !== undefined &&
                                jacket.model !== this.previousModelsJ[index]
                            ) {
                                
                                if (this.hospitalUser.embroidery_position_jacket_logo) {
                                    this.$set(
                                        this.arrayJackets[index],
                                        'logoPosition',
                                        JSON.parse(this.hospitalUser.embroidery_position_jacket_logo)
                                    );
                                }

                                if (this.hospitalUser.embroidery_position_jacket) {
                                    this.$set(this.arrayJackets[index], 'embroid', 'Sí');
                                    this.$set(
                                        this.arrayJackets[index],
                                        'embroidPosition',
                                        JSON.parse(this.hospitalUser.embroidery_position_jacket)
                                    );
                                    this.$set(
                                        this.arrayJackets[index],
                                        'embroidFont',
                                        this.hospitalUser.embroidery_font
                                            ? JSON.parse(this.hospitalUser.embroidery_font)
                                            : null
                                    );
                                    this.$set(
                                        this.arrayJackets[index],
                                        'embroidFontColor',
                                        this.hospitalUser.embroidery_color
                                            ? JSON.parse(this.hospitalUser.embroidery_color)
                                            : null
                                    );
                                }
                            }

                            this.$set(this.previousModelsJ, index, jacket.model);
                        });
                    } finally {
                        this.$nextTick(() => {
                            this._updatingArrayJackets = false;
                        });
                    }
                },
                deep: true
            },
            arrayCoat: {
                handler: function(newVal) {
                    if (this._updatingArrayCoat) return;  // guard
                    this._updatingArrayCoat = true;

                    try {
                        this.sumCoat = this.calculateSum(this.arrayCoat, 'qty');

                        newVal.forEach((coat, index) => {
                            
                            if (!this.arrayCoat[index]) return;

                            if (!coat.model) {
                                this.$set(this.arrayCoat[index], 'qty', 0);
                                this.$set(this.arrayCoat[index], 'color', '');
                                this.$set(this.arrayCoat[index], 'size', '');
                            }

                            if (
                                this.previousModelsC[index] !== undefined &&
                                coat.model !== this.previousModelsC[index]
                            ) {
                                
                                if (this.hospitalUser.embroidery_position_coat_logo) {
                                    this.$set(
                                        this.arrayCoat[index],  // era this.arrayPants[index], bug corregido
                                        'logoPosition',
                                        JSON.parse(this.hospitalUser.embroidery_position_coat_logo)
                                    );
                                }

                                if (this.hospitalUser.embroidery_position_coat) {
                                    this.$set(this.arrayCoat[index], 'embroid', 'Sí');
                                    this.$set(
                                        this.arrayCoat[index],
                                        'embroidPosition',
                                        JSON.parse(this.hospitalUser.embroidery_position_coat)
                                    );
                                    this.$set(
                                        this.arrayCoat[index],
                                        'embroidFont',
                                        this.hospitalUser.embroidery_font
                                            ? JSON.parse(this.hospitalUser.embroidery_font)
                                            : null
                                    );
                                    this.$set(
                                        this.arrayCoat[index],
                                        'embroidFontColor',
                                        this.hospitalUser.embroidery_color
                                            ? JSON.parse(this.hospitalUser.embroidery_color)
                                            : null
                                    );
                                }
                            }

                            this.$set(this.previousModelsC, index, coat.model);
                        });
                    } finally {
                        this.$nextTick(() => {
                            this._updatingArrayCoat = false;
                        });
                    }
                },
                deep: true
            },
            arrayPants:{
                handler: function(newVal) {
                    if (this._updatingArrayPants) return;  // guard
                    this._updatingArrayPants = true;

                    try {
                        this.sumPants = this.calculateSum(this.arrayPants, 'qty');

                        newVal.forEach((pants, index) => {
                            
                            if (!this.arrayPants[index]) return;

                            if (!pants.model) {
                                this.$set(this.arrayPants[index], 'qty', 0);
                                this.$set(this.arrayPants[index], 'color', '');
                                this.$set(this.arrayPants[index], 'size', '');
                            }

                            if (
                                this.previousModelsP[index] !== undefined &&
                                pants.model !== this.previousModelsP[index]
                            ) {
                                if (this.hospitalUser.embroidery_position_pants_logo) {
                                    this.$set(
                                        this.arrayPants[index],  
                                        'logoPosition',
                                        JSON.parse(this.hospitalUser.embroidery_position_pants_logo)
                                    );
                                }

                                if (this.hospitalUser.embroidery_position_pants) {
                                    this.$set(this.arrayPants[index], 'embroid', 'Sí');
                                    this.$set(
                                        this.arrayPants[index],
                                        'embroidPosition',
                                        JSON.parse(this.hospitalUser.embroidery_position_pants)
                                    );
                                    this.$set(
                                        this.arrayPants[index],
                                        'embroidFont',
                                        this.hospitalUser.embroidery_font
                                            ? JSON.parse(this.hospitalUser.embroidery_font)
                                            : null
                                    );
                                    this.$set(
                                        this.arrayPants[index],
                                        'embroidFontColor',
                                        this.hospitalUser.embroidery_color
                                            ? JSON.parse(this.hospitalUser.embroidery_color)
                                            : null
                                    );
                                }
                            }

                            this.$set(this.previousModelsP, index, pants.model);
                        });
                    } finally {
                        this.$nextTick(() => {
                            this._updatingArrayPants = false;
                        });
                    }
                },
                deep: true
            },
            selectedJC:{
                handler:function() {
                    this.arrayJackets[0].size = ''
                    this.arrayCoat[0].size = ''
                    this.arrayJackets[0].color = ''
                    this.arrayCoat[0].color = ''
                },
                deep:true
            }
        },
        methods: {
            getAllOrders(){
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')
                axios
                .post(
                    process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                    qs.stringify({ 
                        api_token: token, 
                        user_id: id_user,
                        option: 'get_orders',
                    }),
                )
                .then((response) => {
                    if (!response.data.error.code) {
                        var listOrders = []
                        Object.keys(response.data.orders).map((key) => [response.data.orders[key]]).map(function(value) {
                            listOrders.push(value[0])
                        })
                        this.ordersUserAll = listOrders
                    }
                })

            },
            submitOrder() {
                this.empty = true
                this.messageEmpty = ''
                if(this.arrayCoat[0].model=='' && this.arrayJackets[0].model=='' && this.arrayScrubs[0].model=='' && this.arrayPants[0].model==''  && this.arrayShoes[0].model==''  ){
                    this.messageEmpty = 'Elige al menos uno de los conjuntos para seguir con el proceso'
                    return
                }
                this.arrayCoat.forEach((element) => {
                        if(element.model != '' && (element.size == '' || element.size == null) && this.hospitalUser.qty_batas > 0){
                            this.messageEmpty = 'Elige la talla de los elementos seleccionados'
                            return
                        }
                    });
                this.arrayJackets.forEach((element) => {
                    if(element.model != '' && (element.size == '' || element.size == null) && this.hospitalUser.qty_chamarras > 0){
                        this.messageEmpty = 'Elige la talla de los elementos seleccionados'
                        return
                    }
                });
                
                this.arrayScrubs.forEach((element) => {
                    if(element.model != '' && (element.size == '' || element.size == null) && this.hospitalUser.qty_filipinas > 0){
                        this.messageEmpty = 'Elige la talla de los elementos seleccionados'
                        return
                    }
                });
                this.arrayPants.forEach((element) => {
                    if(element.model != '' && (element.size == '' || element.size == null) && this.hospitalUser.qty_pantalones > 0){
                        this.messageEmpty = 'Elige la talla de los elementos seleccionados'
                        return
                    }
                });

                this.arrayShoes.forEach((element) => {
                    if(element.model != '' && (element.size == '' || element.size == null) && this.hospitalUser.qty_zapatos > 0){
                        this.messageEmpty = 'Elige la talla de los elementos seleccionados'
                        return
                    }
                });

                if (this.messageEmpty != '')
                {
                    return
                }

                if( this.status &&
                    this.dataUser.hospital &&
                    this.dataUser.name &&
                    this.dataUser.lastname1 &&
                    this.dataUser.gender &&
                    (this.calculateChars() <= this.hospitalUser.max_chars || (this.hospitalUser.max_chars==0 || this.hospitalUser.max_chars==null || this.hospitalUser.max_chars=="null" || this.hospitalUser.max_chars==""))&&
                    (this.dataUser.speciality.length <= this.hospitalUser.max_chars || (this.hospitalUser.max_chars==0 || this.hospitalUser.max_chars==null || this.hospitalUser.max_chars=="null" || this.hospitalUser.max_chars=="")) &&
                    (this.dataUser.name.length >= this.hospitalUser.min_chars || (this.hospitalUser.min_chars==0||this.hospitalUser.min_chars==""||this.hospitalUser.min_chars==null || this.hospitalUser.min_chars=="null")) &&
                    (this.dataUser.lastname1.length >= this.hospitalUser.min_chars || (this.hospitalUser.min_chars==0||this.hospitalUser.min_chars==""||this.hospitalUser.min_chars==null || this.hospitalUser.min_chars=="null")) &&
                    (this.dataUser.lastname2.length >= this.hospitalUser.min_chars || (this.hospitalUser.min_chars==0||this.hospitalUser.min_chars==""||this.hospitalUser.min_chars==null || this.hospitalUser.min_chars=="null"))) {           
                    sessionStorage.setItem('dataUser',JSON.stringify(this.dataUser))
                    sessionStorage.setItem('arrayJackets',JSON.stringify(this.arrayJackets))
                    sessionStorage.setItem('arrayScrubs',JSON.stringify(this.arrayScrubs))
                    sessionStorage.setItem('arrayPants',JSON.stringify(this.arrayPants))
                    sessionStorage.setItem('arrayCoat',JSON.stringify(this.arrayCoat))
                    sessionStorage.setItem('arrayShoes',JSON.stringify(this.arrayShoes))
                    this.$router.push({ name: 'DetailsOrder', params: { data: this.dataUser, arrayJackets: this.arrayJackets, arrayCoat: this.arrayCoat, arrayScrubs: this.arrayScrubs, arrayPants: this.arrayPants, arrayShoes: this.arrayShoes}})
                } else{
                    console.log("vacio")
                }
            },
            applyClothingDefaults(target, modelName, type, qty) {
                target.model = modelName;
                const colors = this.getColors(modelName);
                target.color = colors.length === 1 ? colors[0] : '';
                target.qty = qty;

                const logoKey = type=='scrub' ? `embroidery_position_${type}s_logo` : `embroidery_position_${type}_logo`;
                if (this.hospitalUser[logoKey]) {
                    target.logoPosition = JSON.parse(this.hospitalUser[logoKey]);
                }

                const embroidKey = `embroidery_position_${type}`;
                if (this.hospitalUser[embroidKey]) {
                target.embroid = 'Sí';
                target.embroidFont      = this.hospitalUser.embroidery_font
                    ? JSON.parse(this.hospitalUser.embroidery_font) : '';
                target.embroidFontColor = this.hospitalUser.embroidery_color
                    ? JSON.parse(this.hospitalUser.embroidery_color) : '';
                target.embroidPosition  = JSON.parse(this.hospitalUser[embroidKey]);
                }
            },
            completedStatusOrder(o_id){
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')

                let formData = new FormData()
                    formData.append('api_token', token)
                    formData.append('user_id', id_user)
                    formData.append('option', 'completed_status_order')
                    formData.append('o_id', o_id)
                    axios
                    .post(
                        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    )
                    .then((response) => {
                        this.loading = true
                        console.log(response)
                        if (!response.data.error.code) {
                            this.getAllOrders()
                        } else {
                            this.loading = false
                            this.messageErrorModal = response.data.error.description
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            showPreviewLogo(image){
                return image ? URL.createObjectURL(image) : ''
            },
            handleChange (e, val, modal) {
                console.log(val)
                if (e=='Sí' && !this.storageUser){
                    switch(val.type){
                        case 'Chamarra': 
                                this.elementJackets = val
                                break;
                        case 'Bata': 
                                this.elementCoat = val
                                break;
                        case 'Filipina': 
                                this.elementScrubs = val
                                break;
                        case 'Pantalon': 
                                this.elementPants = val
                                break;
                    }
                    
                    this.$bvModal.show(modal)
                }
                    
            },
            handleModel(val){
                var count = 0   
                
                while(parseInt(val.id) != parseInt(this.arrayPants[count].id) ){
                    count++
                }
                if(val.model){
                    var associated = this.optionsModels.filter((x) => x.name == val.model).map(y => y.associated_model)
                    this.arrayPants[count].model = this.optionsModels.filter((x) => x.id == associated).map(y => y.name).toString()
                } else {
                    this.arrayPants[count].model = ''
                    this.arrayPants[count].color = ''
                    val.color = ''
                    val.qty = 0
                    val.size = 0
                    this.arrayPants[count].qty = 0
                    this.arrayPants[count].size = ''
                }
                if(val.color){
                    this.arrayPants[count].color = val.color
                } else {
                    this.arrayPants[count].color = ''
                }
                if(val.qty){
                    this.arrayPants[count].qty = val.qty
                } else {
                    this.arrayPants[count].qty = 0
                }
            },
            checkCollaborators() {
                var a = this.listCollaborators.filter((x) =>
                    x.number.toString() == this.dataUser.collaborator.toString() )
                    if(a.length > 0){
                        this.dataUser.name = this.$R.prop('name', a[0]) 
                        this.dataUser.area = this.$R.prop('area', a[0]) 
                        this.dataUser.lastname1 = this.$R.prop('first_lastname', a[0])
                        this.dataUser.lastname2 = this.$R.prop('second_lastname', a[0])
                        this.dataUser.gender = this.$R.prop('gender', a[0])
                        this.dataUser.speciality = this.$R.prop('specialty', a[0])
                        this.dataUser.speciality2 = this.$R.prop('specialty2', a[0])
                        this.dataUser.idCollaborator = this.$R.prop('id', a[0])
                        this.dataUser.items = this.$R.prop('items', a[0])
                        this.checkIfCollaboratorsExist = true

                        this.hospitalUser.min_chars = this.$R.prop('min_chars', a[0]) ? this.$R.prop('min_chars', a[0]) : this.hospitalUser.min_chars
                        this.hospitalUser.max_chars = this.$R.prop('max_chars', a[0]) ? this.$R.prop('max_chars', a[0]) : this.hospitalUser.max_chars
                        
                        if(this.dataUser.items.length>0){            

                            if(this.checkItemArea('Bata').length==1){
                                this.arrayCoat[0].model = this.checkItemArea('Bata')[0]
                                this.arrayCoat[0].color = this.getColors(this.arrayCoat[0].model).length == 1 ? this.getColors(this.arrayCoat[0].model)[0] : ''
                                this.arrayCoat[0].qty = parseInt(this.hospitalUser.qty_batas)
                            }
                            if(this.checkItemArea('Bata').length==0){
                                this.arrayCoat[0].model = ""
                                this.arrayCoat[0].color = ""
                                this.arrayCoat[0].qty = 0
                            }
                            if(this.checkItemArea('Pantalon').length==1){
                                this.arrayPants[0].model = this.checkItemArea('Pantalon')[0]
                                this.arrayPants[0].color = this.getColors(this.arrayPants[0].model).length ==1 ? this.getColors(this.arrayPants[0].model)[0] : ''
                                this.arrayPants[0].qty = parseInt(this.hospitalUser.qty_pantalones)
                            }
                            if(this.checkItemArea('Pantalon').length==0){
                                this.arrayPants[0].model = ""
                                this.arrayPants[0].color = ""
                                this.arrayPants[0].qty = 0
                            }
                            if(this.checkItemArea('Filipina').length==1){
                                this.arrayScrubs[0].model = this.checkItemArea('Filipina')[0]
                                this.arrayScrubs[0].color = this.getColors(this.arrayScrubs[0].model).length ==1 ? this.getColors(this.arrayScrubs[0].model)[0] : ''
                                this.arrayScrubs[0].qty = parseInt(this.hospitalUser.qty_filipinas)
                            }
                            if(this.checkItemArea('Filipina').length==0){
                                this.arrayScrubs[0].model = ""
                                this.arrayScrubs[0].color = ""
                                this.arrayScrubs[0].qty = 0
                            }
                            if(this.checkItemArea('Chamarra').length==1){
                                this.arrayJackets[0].model = this.checkItemArea('Chamarra')[0]
                                this.arrayJackets[0].color = this.getColors(this.arrayJackets[0].model).length ==1 ? this.getColors(this.arrayJackets[0].model) : ''
                                this.arrayJackets[0].qty = parseInt(this.hospitalUser.qty_chamarras)
                            }
                            if(this.checkItemArea('Chamarra').length==0){
                                this.arrayJackets[0].model = ""
                                this.arrayJackets[0].color = ""
                                this.arrayJackets[0].qty = 0
                            }
                            if(this.checkItemArea('Calzado').length==1){
                                this.arrayShoes[0].model = this.checkItemArea('Calzado')[0]
                                this.arrayShoes[0].color = this.getColors(this.arrayShoes[0].model).length ==1 ? this.getColors(this.arrayShoes[0].model) : ''
                                this.arrayShoes[0].qty = parseInt(this.hospitalUser.qty_zapatos)
                            }
                            if(this.checkItemArea('Calzado').length==0){
                                this.arrayShoes[0].model = ""
                                this.arrayShoes[0].color = ""
                                this.arrayShoes[0].qty = 0
                            }
                        } 
                    } else {
                        this.checkIfCollaboratorsExist = false
                        this.checkIfCollaboratorsOrderExist = this.ordersUserAll.some(
    order => order.collaborator_number == this.dataUser.collaborator
)
                        this.dataUser.name = ''
                        this.dataUser.items = {}
                        this.dataUser.lastname1 = ''
                        this.dataUser.lastname2 = ''
                        this.dataUser.gender = ''
                        this.dataUser.area = ''
                        this.dataUser.speciality = ''
                        this.dataUser.speciality2 = ''
                        this.dataUser.idCollaborator = ''
                        var tempUserInfo = JSON.parse(sessionStorage.getItem('hospital_user'))
                        if(tempUserInfo){
                            this.hospitalUser.min_chars = tempUserInfo.min_chars
                            this.hospitalUser.max_chars = tempUserInfo.max_chars
                        }
                        this.arrayCoat[0].model = ""
                        this.arrayCoat[0].color = ""
                        this.arrayPants[0].model = ""
                        this.arrayPants[0].color = ""
                        this.arrayScrubs[0].model = ""
                        this.arrayScrubs[0].color = ""
                        this.arrayJackets[0].model = ""
                        this.arrayJackets[0].color = ""
                        this.arrayShoes[0].model = ""
                        this.arrayShoes[0].color = ""
                    

                        // tempUserInfo = JSON.parse(sessionStorage.getItem('hospital_user'))
                        // if(tempUserInfo)
                        //     this.hospitalUser = tempUserInfo
                    }
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault()
                } else {
                    return true;
                }
            },
            editInfoUser(){
                this.tempDataUser.name = this.dataUser.name
                this.tempDataUser.lastname1 = this.dataUser.lastname1
                this.tempDataUser.speciality = this.dataUser.speciality
                this.tempDataUser.speciality2 = this.dataUser.speciality2
                this.editInfo = false
            }, 
            saveEditInfoUser(){
                this.editInfo = true
            }, 
            cancelEditInfoUser(){
                this.dataUser.name = this.tempDataUser.name
                this.dataUser.lastname1 = this.tempDataUser.lastname1
                this.dataUser.speciality = this.tempDataUser.speciality
                this.dataUser.speciality2 = this.tempDataUser.speciality2
                this.editInfo = true

            },
            updateWatchersModel () {
                // Helper function for comparing list items to the "watchModel".
                const getItem = (val) => val.item || val;
               
                // Items that aren't already watched: watch and add to watched list.
                _.differenceBy(this.arrayScrubs, this.watchModel, getItem).forEach((item) => {
                    const unwatch = this.$watch(() => item, (e) => this.handleModel(e), {deep: true});
                    this.watchModel.push({ item: item, unwatch: unwatch });
                    // Uncomment below if adding a new item to the list should count as a "change".
                    // this.handleChange(item);
                });
            },
            updateWatchersEmbroid (array, modal) {
                // Helper function for comparing list items to the "watchTracker".
                const getItem = (val) => val.item || val;
               
                // Items that aren't already watched: watch and add to watched list.
                _.differenceBy(array, this.watchTracker, getItem).forEach((item) => {
                    const unwatch = this.$watch(() => item.embroid, (e) => this.handleChange(e, item, modal), {deep: true});
                    this.watchTracker.push({ item: item, unwatch: unwatch });
                    // Uncomment below if adding a new item to the list should count as a "change".
                    // this.handleChange(item);
                });
            },
            updateWatchersLogo (array, modal) {
                const getItem = (val) => val.item || val;
               _.differenceBy(array, this.watchTrackerLogo, getItem).forEach((item) => {
                    const unwatch = this.$watch(() => item.logo, (e) => this.handleChange(e, item, modal), {deep: true});
                    this.watchTrackerLogo.push({ item: item, unwatch: unwatch });
                });
            },
            getColors(index){
                if (index) {
                    if(this.dataUser.items.length)
                        return this.dataUser.items.filter((x) => x.model == index).map(y => y.color)
                    else{
                        let sharedColor = this.optionsModels.filter((x) => x.name == index).map(y => y.sharedColor)[0]
                        return sharedColor ? sharedColor.map(z => z.name) : []
                    }
                } else {
                    return ''
                }
            },
            getThreadsColors(index){
                if (index) {
                    return this.optionsModels.filter((x) => x.name == index).map(y => y.threads)[0]
                } else {
                    return ''
                }
            },
            getSizes(index){
                if (index) {
                    let sharedSize = this.optionsModels.filter((x) => x.name == index).map(y => y.sharedSize)[0]
                    return sharedSize ? sharedSize.map(z => z.name) : []
                } else {
                    return ''
                }
            },
            saveInfoModal(index){
                switch(index){
                    case 1:
                        this.dataUser.saveJacket = true;
                        this.$bvModal.hide('modal-jacket')
                        break
                    case 2:
                        this.dataUser.saveCoat = true;
                        this.$bvModal.hide('modal-coat')
                        break
                    case 3:
                        this.dataUser.saveScrub = true;
                        this.$bvModal.hide('modal-scrub')
                        break
                    case 4:
                        this.dataUser.savePants = true;
                        this.$bvModal.hide('modal-pants')
                        break
                }
            },
            saveLogoModal(index){
                switch(index){
                    case 1:
                        this.$bvModal.hide('modal-jacket-logo')
                        break
                    case 2:
                        this.$bvModal.hide('modal-coat-logo')
                        break
                    case 3:
                        this.$bvModal.hide('modal-scrub-logo')
                        break
                    case 4:
                        this.$bvModal.hide('modal-pants-logo')
                        break
                }
            },
            addNewScrub () {
                this.arrayScrubs.push({
                    qty: 0,
                    model: '',
                    size: '',
                    id: this.arrayScrubs.length+1,
                    color: '',
                    logo: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Filipina',
                    save: false
                })
                this.addNewPants ()
            },
            addNewCoat () {
                this.arrayCoat.push({
                    qty: 0,
                    model: '',
                    size: '',
                    id: this.arrayCoat.length+1,
                    color: '',
                    logo: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Bata',
                    save: false
                })
            },
            addNewPants () {
                this.arrayPants.push({
                    qty: 0,
                    model: '',
                    size: '',
                    id: this.arrayPants.length+1,
                    color: '',
                    logo: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Pantalon',
                    save: false
                })
            },
            addNewJackets () {
                this.arrayJackets.push({
                    qty: 0,
                    model: '',
                    size: '',
                    id: this.arrayJackets.length+1,
                    color: '',
                    logo: '',
                    logoFile: '',
                    embroid: '',
                    embroidText: '',
                    embroidPosition: '',
                    embroidFont: '',
                    embroidFontColor: '',
                    type: 'Chamarra',
                    save: false
                })
            },
            showModalOrderDetails(index){
                this.index = this.ordersUser.findIndex(o => o.id === index)
                this.$bvModal.show('modal-view-order')
            },
            calculateSum(array, property) {
                const total = array.reduce((accumulator, object) => {
                    return accumulator + object[property];
                }, 0);

                return total;
            },
            calculateChars() {
                const total = this.dataUser.name.length + this.dataUser.lastname1.length + this.dataUser.lastname2.length

                return total;
            },
            checkItemArea(type){
                if(this.dataUser.items){
                    return this.dataUser.items.filter(x => x.type  == type).map(y => y.model)
                } else {
                    return []
                }
            }
        },
        computed: {
            ordersUser() {
                let result = this.ordersUserAll;

                // Filtro por estatus
                if (this.statusFilter === 'Entregado') {
                    result = result.filter(element => element.status === 'Entregado');
                } else if (this.statusFilter === 'No entregado') {
                    result = result.filter(element => element.status !== 'Entregado');
                }
                // si statusFilter === 'all', no se filtra por estatus

                // Filtro por búsqueda
                if (this.search && this.search.trim() !== '') {
                    const searchTerm = this.search.trim().toLowerCase();
                    result = result.filter(element =>
                        String(element.collaborator_number).toLowerCase().includes(searchTerm)
                    );
                }

                return result;
            },
            filteredOrdersCompleted() {
                return this.ordersUserAll.filter(element => 
                    String(element.status).toLowerCase().includes('entregado')
                    );
            },
           hasClothesType: function() {
                if (!this.dataUser.gender && !this.dataUser.collaborator) return '';

                const gender = this.dataUser.gender.toLowerCase();
                const isMale = gender === 'hombre';
                const genderIds = isMale ? ['1', '3', '4'] : ['2', '3', '5'];

                const filterByTypeAndGender = (typeId) =>
                    this.optionsModels
                    .filter(x => x.type_id === typeId && genderIds.includes(x.gender_id))
                    .map(y => y.name);

                return {
                    scrub:   filterByTypeAndGender('2'),
                    pants:   filterByTypeAndGender('3'),
                    coat:    filterByTypeAndGender('5'),
                    jacket:  filterByTypeAndGender('4'),
                    shoes:   filterByTypeAndGender('6'),
                    caps:    filterByTypeAndGender('7'),
                };
            },
            // hasClothesType: function(){
            //     if (this.dataUser.gender && this.dataUser.collaborator) {
            //         let elements = {
            //             scrub: [],
            //             pants: [],
            //             coat: [],
            //             jacket: [],
            //             shoes: [],
            //             caps: []
            //         }
            //         if(this.dataUser.items.length>0){
            //             elements.scrub =  this.checkItemArea('Filipina')
            //             elements.pants = this.checkItemArea('Pantalon')
            //             elements.coat = this.checkItemArea('Bata')
            //             elements.jacket  = this.checkItemArea('Chamarra')
            //             elements.shoes = this.checkItemArea('Calzado')
            //             elements.caps  = this.checkItemArea('Gorro')
                    
            //         } else {
            //             if (this.dataUser.gender.toLowerCase() == 'hombre') {
            //                 elements.scrub =  this.optionsModels.filter((x) => x.type_id == '2' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            //                 elements.pants = this.optionsModels.filter((x) => x.type_id == '3' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            //                 elements.coat = this.optionsModels.filter((x) => x.type_id == '5' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            //                 elements.jacket  = this.optionsModels.filter((x) => x.type_id == '4' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            //                 elements.shoes = this.optionsModels.filter((x) => x.type_id == '6' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            //                 elements.caps  = this.optionsModels.filter((x) => x.type_id == '7' && (x.gender_id == '1' || x.gender_id == '3' || x.gender_id == '4')).map(y => y.name)
            //             } else {
            //                 elements.scrub =  this.optionsModels.filter((x) => x.type_id == '2' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            //                 elements.pants = this.optionsModels.filter((x) => x.type_id == '3' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            //                 elements.coat = this.optionsModels.filter((x) => x.type_id == '5' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            //                 elements.jacket  = this.optionsModels.filter((x) => x.type_id == '4' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            //                 elements.shoes = this.optionsModels.filter((x) => x.type_id == '6' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            //                 elements.caps  = this.optionsModels.filter((x) => x.type_id == '7' && (x.gender_id == '2' || x.gender_id == '3' || x.gender_id == '5')).map(y => y.name)
            //             }
            //         }

                    
            //         return elements 
            //     } else {
            //         return ''
            //     }
            // }
        }
    }
</script>

<style scoped>
.order-container{
    padding: 70px 12% 70px 7%;
}
.full-height{
    height: 100vh;
}
.fixed-div{
    position: fixed;
    background: #5A6FBE;
    background-image: url('../../assets/imgs/img_photo.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    max-height: 100vh;
}
.logo-hospital{
    background-color: #fff;
    text-align: center;
    align-self: end;
    padding: 10%;
    min-height: 100px;
}
h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p{
   font-size: 14px; 
}
.note{
    font-size: 14px;
    color: #5965B1;
}
.btn,
.btn:focus,
.btn:hover{
    background: #F15E1A;
    border: none;
    width: 100%;
}
.btn-group{
    width: 100%;
}

.btn-wrapper {
    display: flex;
}
.btn-wrapper .btn{
    width: 40%;
    max-width: 300px;
    margin-right: 5%;
}
.btn-wrapper .btn-cancel{
    color: #F15E1A;
    background: rgba(241, 94, 26, 0.1);
}

legend {
    color: rgba(89, 101, 177, 1);
    float: none;
    width: fit-content;
    padding: 0;
    margin-bottom: 0.5rem;
    margin-left: 1rem;
    font-size: 15px;
    line-height: inherit;
    margin-bottom: 0;
}
fieldset{
    border: 1px solid #5965B1;
    border-radius: 5px;
    position: relative;
}
fieldset label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
fieldset label.show{
    color: rgba(89, 101, 177, 1) !important;
}
.size-container{
    position: relative;
}

.size-container label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.size-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.size-container.coat-container label{
    left: calc(2rem - 2px);
    color: rgba(89, 101, 177, 0.4);
}
.size-container.coat-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.qty-container{
    position: relative;
    width: 100%;
    border:1px solid #5965B1 !important;
    border-radius: 5px;
    padding: 0.4rem 0.5rem;
    height: 100%;
}
.qty-container.required{
    border-color: #D85067 !important;
}
.wrapper-gender-check{
    border:1px solid #5965B1 !important;
    border-radius: 5px;
    height: 45px;
    margin: 0 10px;
    padding-top: 10px;
    width: calc(50% - 20px);
}
.radioBtn-border{
    border: 1px solid rgba(89, 101, 177, 1);
}
.embroid-container{
    border-radius: 5px;
    width: 100%;
    display: -webkit-flex;
    display: flex;
}
.embroid-container label{
    margin-right: 20px;
    margin-left: 1.1rem;
    margin-top: 0.6rem;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.embroid-container.show label{
    color: rgba(89, 101, 177,1) !important;
}
.embroid-container .radioBtn{
    width: inherit;
}
.required-label{
    color: #D85067;
    font-size: 10px;
    position: absolute;
    display: none;
}
.required-label-qty{
    color: #D85067;
    font-size: 11px;
    display: none;
}
.showlabel.required-label,
.showlabel.required-label-qty{
    display: block;
}
.wrapper-social-media-form{
    position: absolute;
    bottom: 10%;
}
.wrapper-social-media-form a{
    margin: 12px;
}
.td-number{
    width: 20%;
}
.td-btn-details{
    width: 120px;
}
.orders-count-wrapper{
    padding: 20px 15px; 
    border: 1px solid #d2d2d2; 
    border-radius: 15px;
    height: 100%;
    width: 100%;
}

#modal-view-order p{
    color: #000;
    font-weight: normal;
    text-align: left;
    display: block;
    width: 100%;
    height: calc(1.5em + 1.25rem + 2px);
    padding: 0.625rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #cad1d7;
    border-radius: 0.375rem;
    font-size: 0.875rem;
}
#modal-view-order b{
    color: #525f7f;
    font-size: 0.875rem;
    font-weight: 600;
}
#modal-view-order .title-modal-order{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #8898aa !important;
    text-align: left;
    margin-left: -3%;
    margin-bottom: 20px;
}
.text-left{
    text-align: left;
}

@media (max-width: 1600px) {
    .order-container{
        padding: 70px 10% 70px 6%;
    }
    h3{
        font-size: 20px;
    }
    p{
        font-size: 12px; 
    }
    .note{
        font-size: 11px;
    }
    legend {
        font-size: 12px;
    }
    .logo{
        width: 70%;
    }
    .qty-container{
        height: 45px;
    }
    .size-container label{
        bottom: 25%;
        font-size: 14px;
    }
    .size-container.coat-container label{
        left: 2rem;
        font-size: 14px;
    }
    .embroid-container label,
    fieldset label{
        font-size: 14px;
    }
    .wrapper-social-media-form{
        margin-top: 50px;
    }
    .wrapper-social-media-form a{
        margin: 10px;
    }
    .wrapper-social-media-form img{
        width: 40px;
    }
}



.wrapper-details{
    background: rgba(247, 249, 255, 0.5);
    padding: 18px;
}
.wrapper-details p{
    color: #112357;
    margin-bottom: 0px;
    font-size: 16px !important;
}
.wrapper-details span{
    color: #112357;
    margin-bottom: 0px;
    font-weight: 500;
}
.wrapper-details .title{
    color: #5965B1;
    font-weight: 600 !important;
    font-size: 16px;
    margin-bottom: 0px;
}
.img-modal{
    border: 1px solid #5965B1;
    width: 100%;
    border-radius: 5px;
}
.img-back-modal{
    opacity: 0.5 !important;
}
.modal-body p{
    text-align: center;
    color: #5965B1;
    font-weight: bold;
    font-size: 19px;
}
.modal-body .btn{
    margin-top: 20px;
    width: 100px;
}

.image-preview{
    position: absolute;
    top: 2.5%;
    left: calc(2.5% + 15px);
    max-height: calc(95% - 1.5em - 0.75rem - 2px);
    max-width: 80%;
}
.see-details-btn{
    color: #F15E1A;
    font-size: 15px;
    background: rgba(241, 94, 26, 0.1);
}
@media (max-width: 1600px) {
    .see-details-btn{
        font-size: 13px;
    }
}

@media (max-width: 991px) {
    .fixed-div{
        position: relative;
        background: #5A6FBE;
        padding: 10% 0 0 0;
        width: 100%;
        overflow-x: hidden;
    }   
    .logo-hospital{
        margin-top: 50px;
    }
    .full-height{
        height: fit-content;
    }

    .wrapper-social-media-form{
        position: relative;
        bottom: 10%;
    }

    .btn-wrapper .btn{
        width: 100%;
        max-width: 100%;
        margin-right: 0;
    }
}

@media (max-width: 768px) {
    .order-container{
        padding: 50px 5% 50px 5%;
    }
    .wrapper-social-media-form{
        margin-top: 70px;
    }
}
</style>
